import { render, staticRenderFns } from "./bests-ranking.component.vue?vue&type=template&id=418e5bae&scoped=true"
import script from "./bests-ranking.component.vue?vue&type=script&lang=js"
export * from "./bests-ranking.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e5bae",
  null
  
)

export default component.exports